import React from 'react';
import { CheckCircle, Circle, FileText, CreditCard, ArrowRight, XCircle, Clock } from 'lucide-react';

/**
 * MilestoneCard — Inline timeline milestone in conversation thread.
 * Derived at read-time from live proposal/booking/payment state.
 * Not a persisted entity.
 */
const MilestoneCard = ({ milestone }) => {
  if (!milestone) return null;

  const { type, title, detail, status, timestamp } = milestone;

  const iconMap = {
    proposal: FileText,
    payment_status: CreditCard,
    booking_status: CheckCircle,
  };

  const Icon = iconMap[type] || Circle;

  const colorMap = {
    completed: { bg: 'bg-emerald-50', border: 'border-emerald-200', icon: 'text-emerald-500', text: 'text-emerald-800' },
    active: { bg: 'bg-blue-50', border: 'border-blue-200', icon: 'text-blue-500', text: 'text-blue-800' },
    default: { bg: 'bg-slate-50', border: 'border-slate-200', icon: 'text-slate-400', text: 'text-slate-700' },
  };

  const colors = colorMap[status] || colorMap.default;

  const formatDate = (ts) => {
    if (!ts) return '';
    try {
      const d = new Date(ts);
      return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) + ', ' + d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
    } catch {
      return '';
    }
  };

  return (
    <div
      data-testid="milestone-card"
      className={`mx-6 my-1.5 flex items-start gap-2.5 px-3 py-2 rounded-lg border ${colors.bg} ${colors.border}`}
    >
      <div className={`mt-0.5 shrink-0 ${colors.icon}`}>
        {status === 'completed' ? <CheckCircle className="w-3.5 h-3.5" /> : <Icon className="w-3.5 h-3.5" />}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-baseline justify-between gap-2">
          <span className={`text-xs font-semibold ${colors.text}`}>{title}</span>
          <span className="text-[10px] text-slate-400 shrink-0">{formatDate(timestamp)}</span>
        </div>
        {detail && (
          <p className="text-[11px] text-slate-500 mt-0.5 truncate">{detail}</p>
        )}
      </div>
    </div>
  );
};

export default MilestoneCard;
